/**
 * SwUpdateStore (Plan 01-15, Task 1).
 *
 * Zustand slice owned by the FND-02 service-worker update UX. Plan 01-08's
 * `registerSW()` is unchanged — it owns the `controllerchange` reload guard
 * via a module-level boolean. Plan 01-15 layers a SECOND `registerSW()` call
 * (from `useSwUpdate`) whose `onNeedRefresh` callback flips this slice from
 * `{ hasUpdate: false, waitingReg: null }` → `{ hasUpdate: true, waitingReg: reg }`.
 *
 * Consumers:
 *   - `<SwUpdateBanner />` (phone / desktop) — subscribes; renders when
 *     `hasUpdate && deviceClass !== 'tablet'`. Tap → sendSkipWaiting(reg) →
 *     SW activates → controllerchange (Plan 08) → location.reload().
 *   - `<SwIdleReload />` (tablet) — subscribes; renders when
 *     `hasUpdate && isIdle && deviceClass === 'tablet'`. After a 500ms fade
 *     (or 0ms under prefers-reduced-motion), sendSkipWaiting + reload.
 *
 * `clear()` exists for completeness (e.g. tests, future "dismiss" UX); the
 * banner itself is NOT dismissable per FND-02 reliability requirement.
 */
import { create } from 'zustand';

export interface SwUpdateState {
  hasUpdate: boolean;
  waitingReg: ServiceWorkerRegistration | null;
  setUpdate: (reg: ServiceWorkerRegistration) => void;
  clear: () => void;
}

export const useSwUpdateStore = create<SwUpdateState>((set) => ({
  hasUpdate: false,
  waitingReg: null,
  setUpdate: (reg) => set({ hasUpdate: true, waitingReg: reg }),
  clear: () => set({ hasUpdate: false, waitingReg: null }),
}));
